export default "__VITE_ASSET__CiAKKX6x__"